import { render, staticRenderFns } from "./ModelsList.vue?vue&type=template&id=041f0ada&"
import script from "./ModelsList.vue?vue&type=script&lang=ts&"
export * from "./ModelsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports